import React, { useContext, useState } from "react";
import styled from "@emotion/styled";
import colors, {
  StyledForm,
  Success,
  Cancel,
} from "./../../components/300/UiComponent";
import { Form, useFormik } from "formik";
import { css } from "@emotion/react";
import * as yup from "yup";
import api from "../../api/authApi";
import ImportStaff from "../300/course/ImportModal";
import CircularProgress from "@mui/material/CircularProgress";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";

//context provider
// import PositionContext from "../../context/PositionContext";
import RankContext from "../../context/RankContext"

import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
} from "@mui/material";
import { FormatLineSpacing } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from "../../components/300/styles";
// Here the drop down menu

const validationSchema = yup.object({
  academicTitle: yup
    .string("Enter Academic Title")
    .required("Academic title is required"),
  payment_rate: yup
    .number("Enter payment rate ")
    .required("Payment rate is required"),
});

function RegisterRank() {
  const rankContext = useContext(RankContext);
  const api = useAxiosPrivate();
  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);

  //for snackbar
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });
  const formik = useFormik({
    initialValues: {
      academicTitle: "",
      payment_rate: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let newValues = { ...values };
      alert(JSON.stringify(newValues, null, 2));
      console.log(newValues);
      setAdding(true);
      api
        .post("/rank/addRank", newValues) //define and edit add rank route
        .then((res) => {
          setAdding(false);
          setSnackBarOpen(true);
          setMessage({ message: res.data.message, type: "success" });
        })
        .catch((err) => {
          setAdding(false);
          setSnackBarOpen(true);
          console.log(err);
          setMessage({ message: err.response.data.message, type: "error" });
        });
    },
  });

  return (
    <StyledForm onSubmit={formik.handleSubmit}>
      <Box sx={header}>
        <Typography
          variant="span"
          sx={{
            fontSize: "1.14rem",
            fontWeight: "600",
            lineHeight: "23.2px",
            color: "primary.main",
          }}
        >
          Add Rank
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            setOpen(true);
          }}
        >
          Import
        </Button>
      </Box>
      <Box sx={formGroupContainer}>
        <Box sx={{ ...row, padding: "40px 0px" }}>
          <FormControl sx={groupStyled}>
            <FormLabel sx={labelStyled}>Title</FormLabel>
            <TextField
              id="academicTitle"
              name="academicTitle"
              value={formik.values.academicTitle}
              onChange={(e) => {
                setSnackBarOpen(false);
                formik.handleChange(e);
              }}
              error={formik.errors.academicTitle && Boolean(formik.errors.academicTitle)}
              helperText={formik.touched.academicTitle && formik.errors.academicTitle}
              fullWidth
            />
          </FormControl>

          <FormControl sx={groupStyled}>
            <FormLabel htmlFor="position_load" sx={labelStyled}>
              Payment Rate
            </FormLabel>
            <TextField
              id="payment_rate"
              name="payment_rate"
              onChange={formik.handleChange}
              error={
                formik.touched.payment_rate &&
                Boolean(formik.errors.payment_rate)
              }
              type="number"
              value={formik.values.payment_rate}
              helperText={
                formik.touched.payment_rate && formik.errors.payment_rate
              }
            />
          </FormControl>
        </Box>
      </Box>
      {snackBarOpen && (
        <CustomizedSnackbars {...{ setSnackBarOpen, snackBarOpen, message }} />
      )}

      <Box
        sx={{
          display: "flex",
          gap: "1.8rem",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <NavLink to={"../"} style={{ textDecoration: "none" }}>
          <Button variant="outlined" color="third">
            Cancel
          </Button>
        </NavLink>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "secondary.main",
            "&:hover": {
              backgroundColor: "secondary.hover",
            },
          }}
          // type="submit"
        >
          Register
        </Button>
      </Box>
    </StyledForm>
  );
}

export default RegisterRank;
